import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { WarehouseEntity } from './warehouse.entity';

/**
 * One row per (client, warehouse), soft-deleted rows included: a removed link
 * is restored, never added a second time. PD-16750 added the unique index
 * `client_warehouse_client_warehouse_unique` on (fk_client__id,
 * fk_warehouse__id) in migration 1790967959195, which first removes the
 * duplicate copies. It is not declared here yet because database sync runs
 * before migrations, and sync creating it while copies still exist would fail.
 * Declare it here, under the same name, once every tenant has run that
 * migration.
 */
@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Entity('client_warehouse')
export class ClientWarehouseEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_warehouse__id', unsigned: true })
	public fkWarehouseId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => WarehouseEntity, (warehouse) => warehouse.clientWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public fkWarehouse!: WarehouseEntity;
}
